import { useCallback, useRef, useState } from 'react';

export interface UseCountdownResult {
    countdown: number;
    startTimer: () => void;
    stopTimer: () => void;
}

const SECOND = 1000;

export default function useCountdown(seconds: number): UseCountdownResult {
    const [countdown, setCountdown] = useState(seconds);
    const timerRef = useRef<any>(null);

    const startTimer = useCallback(() => {
        const runCountdownTimer = () => {
            clearTimeout(timerRef.current);
            const timerId = setTimeout(() => {
                setCountdown((_countdown) => {
                    if (_countdown > 0) {
                        runCountdownTimer();
                        return _countdown - 1;
                    }
                    return _countdown;
                });
            }, SECOND);

            timerRef.current = timerId;
        };
        setCountdown(seconds);
        runCountdownTimer();
    }, []);

    const stopTimer = useCallback(() => {
        clearTimeout(timerRef.current);
        timerRef.current = null;
    }, []);

    return { countdown, startTimer, stopTimer };
}
